import {
    Input
} from '@angular/core';

export class DateRange {
    constructor(public Start?: any, public Finish?: any) { }

    @Input() StartText: string; 
    @Input() FinishText: string; 
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/objects/date-range.ts